import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import WOW from "wowjs";
import "animate.css";
import { FaAngleDoubleRight, FaInfoCircle } from "react-icons/fa";
import { useGetTransformationsQuery } from "../../store/api";
import { useGeneralSheetHook } from "../../hooks/sheet.hook";

const stages = [
  {
    title: "Selection",
    description:
      "Children out on the streets are selected and interviewed before undergoing a raffle draw for school sponsorship.",
  },
  {
    title: "Parent’s Engagement",
    description:
      "The selected child’s parents are then visited, interviewed and informed of their child’s selection for sponsorship into school.",
  },
  {
    title: "Award",
    description:
      "A symbolic cheque is presented to the child, while the cash award is presented to the parent.",
  },
  {
    title: "Enrollment",
    description:
      "The child is enrolled in a school, with all expenses directly paid and managed (school fees, uniform, books, etc.).",
  },
  {
    title: "Follow Up",
    description:
      "Periodic visits are made to the child as follow up on the child’s progress, while the child’s school fees and associated needs will be provided up till the child’s graduation from secondary school",
  },
];

const ConceptTransformation = () => {
  const { data, error, isLoading } =
    useGetTransformationsQuery("transformation");

  const sheet_data = useGeneralSheetHook();

  let publicUrl = process.env.PUBLIC_URL + "/";

  useEffect(() => {
    new WOW.WOW().init();
  }, []);

  useEffect(() => {
    const $ = window.$; // Ensure jQuery is available
    if ($(".video-popup").length) {
      $(".video-popup").magnificPopup({
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: true,
        fixedContentPos: false,
      });
    }
  }, []);

  return (
    <>
      <Container className="my-5">
        <Row>
          <Col md={12} className="text-center mb-4">
            <p className="wow fadeInUp" data-wow-delay="0.2s">
              Heroes of Tomorrow is a CSR-based school sponsorship
              initiative designed to reach out to out-of-school children and
              their parents; parents who do not have the capacity to pay for
              their children’s education. It is aimed at actively getting
              out-of-school children into schools, by sponsoring their
              education, particularly addressing children who are out-of-school
              due to poverty. The initiative deploys a competitive approach to
              make the potential beneficiaries compete for a sponsorship
              opportunity to go to school. It is five-stage cycle that
              incorporates:
            </p>
          </Col>
        </Row>

        <Row>
          {stages.map((stage, index) => (
            <Col md={6} lg={4} className="mb-4" key={index}>
              <div
                className="wow fadeInUp"
                data-wow-delay="100ms"
                style={{ width: "100%" }}
              >
                <div className="feature-two__single">
                  <div className="feature-two__content">
                    <div className="feature-two__top">
                      <div className="feature-two__icon">
                        <span>
                          <FaAngleDoubleRight />
                        </span>
                      </div>
                      <h3 className="feature-two__title">
                        <Link to={process.env.PUBLIC_URL + `/about`}>
                          {stage.title}
                        </Link>
                      </h3>
                    </div>
                    <p className="feature-two__text">{stage.description}</p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <section className="two-section">
          <div className="two-section__wrapper">
            <div
              className="two-section__left wow slideInLeft p-2"
              data-wow-delay="100ms"
              data-wow-duration="2500ms"
            >
              <div className="two-section__content-box">
                <p
                  className="two-section__sub-title"
                  style={{ textAlign: "left" }}
                >
                  All engagements and the stories of the children and their
                  parents are captured on video and retold. Their stories of
                  transformation provide audiences with emotive connections with
                  the lives of children and their parents.
                </p>
              </div>
            </div>
            <div
              className="two-section__right wow slideInRight p-2"
              data-wow-delay="100ms"
              data-wow-duration="2500ms"
            >
              <div className="two-section__content-box">
                <p className="text-white">
                  Heroes of Tomorrow was borne out of the need to:
                </p>
                <ul
                  className="list-unstyled about-one__points wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <li>
                    <div className="icon">
                      <span className="icon-comment"></span>
                    </div>
                    <div className="text">
                      <h4 className="text-white" style={{ textAlign: "left" }}>
                        Reduce the growing rate of out-of-school children in
                        Nigeria.
                      </h4>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-comment"></span>
                    </div>
                    <div className="text">
                      <h4 className="text-white" style={{ textAlign: "left" }}>
                        Improve the social outlook by increasing school
                        enrollment.
                      </h4>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-comment"></span>
                    </div>
                    <div className="text">
                      <h4 className="text-white" style={{ textAlign: "left" }}>
                        Reduce risks of violence and crime related to lack of
                        education.
                      </h4>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-comment"></span>
                    </div>
                    <div className="text">
                      <h4 className="text-white" style={{ textAlign: "left" }}>
                        Increase the number of educated and skilled individuals
                        for a better future.
                      </h4>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div className="mt-5">
          <div
            className="col-xl-12 col-lg-12 wow fadeInUp"
            data-wow-delay="100ms"
          >
            <div
              className="recent-event__single border"
              style={{
                display: "flex",
                justifyContent: "space-between",
                background: "#f7f7f7",
                position: "relative",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  // position: "absolute",
                  top: 0,
                  left: 0,
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="about-one__video-link nomx">
                  <a
                    href={sheet_data.youtube ? sheet_data.youtube : ""}
                    className="video-po"
                    target="_blank"
                  >
                    <div className="about-one__video-icon">
                      <span className="fa fa-play"></span>
                      <i className="ripple"></i>
                    </div>
                  </a>
                </div>
              </div>
              <div className="recent-event__content" style={{ width: "70%" }}>
                <ul className="list-unstyled recent-event__meta">
                  <li>
                    <p>
                      <span className="icon-calendar"></span>{" "}
                      {sheet_data.youtube_last_date || "17 Mar 2025"}
                    </p>
                  </li>
                  <li>
                    <p>
                      <span className="icon-back-in-time"></span>{" "}
                      {sheet_data.youtube_last_time || "04:00 PM"}
                    </p>
                  </li>
                </ul>
                <h3
                  className="recent-event__title"
                  style={{ cursor: "pointer" }}
                >
                  <Link to={sheet_data.youtube} target="_blank">
                    {"Witness the Transformation"}
                  </Link>
                </h3>
                <p className="recent-event__text">
                  {
                    "Explore our journey of impact and innovation. Watch how our heroes of tomorrow project is changing lives and businesses on our YouTube channel."
                  }
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-5">
          {(data || []).map((evt, i) => (
            <div
              className="col-xl-6 col-lg-6 wow fadeInUp"
              data-wow-delay="100ms"
              key={i}
            >
              <div
                className="recent-event__single border"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  background: "#f7f7f7",
                  position: "relative",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    // position: "absolute",
                    top: 0,
                    left: 0,
                    width: "50%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div className="about-one__video-link nomx">
                    <a href={evt.video_url} className="video-popup">
                      <div className="about-one__video-icon">
                        <span className="fa fa-play"></span>
                        <i className="ripple"></i>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="recent-event__content">
                  <ul className="list-unstyled recent-event__meta">
                    <li>
                      <p>
                        <span className="icon-calendar"></span> {evt.date}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span className="icon-back-in-time"></span> {evt.time}
                      </p>
                    </li>
                  </ul>
                  <h3 className="recent-event__title">
                    <Link to={process.env.PUBLIC_URL + `/events`}>
                      {evt.title}
                    </Link>
                  </h3>
                  <p className="recent-event__text">{evt.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default ConceptTransformation;
